import { render } from "./EditTableItem.vue?vue&type=template&id=aa939006&scoped=true&ts=true"
import script from "./editTableItemHelper.ts?vue&type=script&lang=ts"
export * from "./editTableItemHelper.ts?vue&type=script&lang=ts"

import "./EditTableItem.vue?vue&type=style&index=0&id=aa939006&scoped=true&lang=scss"

import exportComponent from "D:\\softwhere\\tools\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa939006"]])

export default __exports__